import { ExperimentalIFrameBasic } from 'ui/baseComponents'
import MainNav from 'ui/components/MainNav'
import { HEADER_HEIGHT } from 'ui/components/MainNav'
import { Box } from '@mui/material'
import { colors } from 'theme/colors'

const AiChat = () => {
  const STYLES = {
    fullHeightWrapper: {
      backgroundColor: colors.COOL[100],
      height: `calc(100vh - ${HEADER_HEIGHT}px)`,
      width: '100vw',
      padding: 0,
      margin: 0,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
    },
    contentContainer: {
      backgroundColor: colors.WHITE,
      height: '100%',
      width: '100%',
      padding: 0,
      margin: 0,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
    },
    iframeContainer: {
      height: '100%',
      width: '100%',
      overflow: 'hidden',
      position: 'relative',
      '& iframe': {
        border: 'none',
        outline: 'none',
        display: 'block',
      },
    },
  }

  return (
    <>
      <MainNav />
      <Box sx={STYLES.fullHeightWrapper}>
        <Box sx={STYLES.contentContainer}>
          <Box sx={STYLES.iframeContainer}>
            <ExperimentalIFrameBasic
              widget="opensearch-chat"
              widgetTitle="OpenSearch Chat"
              height="100%"
              width="100%"
            />
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default AiChat
